var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"text-base font-semibold"},[_c('Icon',{staticClass:"mr-6",attrs:{"icon":['far', 'angle-right'],"size":16}}),_vm._v(_vm._s(_vm.content))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }